import { render, staticRenderFns } from "./Kriminal.vue?vue&type=template&id=24f92a7a&"
import script from "./Kriminal.vue?vue&type=script&lang=js&"
export * from "./Kriminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports